import _createClass from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var IEvents = /*#__PURE__*/_createClass(function IEvents() {
  _classCallCheck(this, IEvents);
});